<template>
  <div class="form-file">
    <div
      class="block h--140px mr--12px position--relative bg"
      :class="`${loadedImage === '' ? 'form-file__thum' : ''} ${extraClass.bgColor} ${extraClass.width}`"
      :style="loadedImage"
    >
      <template v-if="loadedImage === ''">
        <input
          type="file"
          class="form-file__input"
          @change="handleFileAdd($event)"
          :ref="name"
          :accept="acceptStr"
        />
        <label class="form-file__icon">
          <i class="material-icons">
            add
          </i>
        </label>
      </template>
      <div
        class="form-file__edit"
        v-else
      >
        <form-button
          class="icon--btn font--24px text--white col-m-4"
          icon="search"
        ></form-button>

        <div class="col-m-4 position--relative">
          <form-button
            class="icon--btn font--24px text--white"
            icon="edit"
            @click.prevent.stop="aaa"
          ></form-button>
          <input
            type="file"
            class="position--absolute left--0px top--0px opacity--0 w--100% h--100%"
            @change="handleFileAdd($event)"
            :ref="name"
            :accept="acceptStr"
          >
        </div>

        <form-button
          style="z-index: 1000"
          class="icon--btn font--24px text--white col-m-4"
          icon="close"
          @click.stop.prevent="removeFile"
        ></form-button>
      </div>

    </div>
    <span class="font--14px text--gray text--darken-2 mx--16px">{{uploadStatus}}</span>

    <form-error
      :error="error"
      :name="name"
    ></form-error>
    <!-- <help-text label="권장 크기 : 640 x 640 (윈도대상 750 x 1000)"></help-text> -->
    <div
      v-html="helpHtml"
      v-if="helpHtml"
    ></div>
    <help-text
      :label="helpText"
      v-else
    ></help-text>
  </div>
</template>

<script>
import focusOnError from '@/component/ui/focusOnError'

export default {
  mixins: [focusOnError],
  props: {
    error: { type: Object, required: true },
    url: { type: String, required: true },
    name: { type: String, required: true },
    required: { type: Boolean, default: false },
    extraClass: {
      type: Object,
      default: () => {
        return {
          width: 'w--140px',
          bgColor: ''
        }
      }
    },
    helpText: { type: String, default: '' },
    helpHtml: { type: String, default: '' },
    accept: { type: Array }
  },
  data () {
    return {
      uploadStatus: '',
      loadState: '',
      asyncImage: new Image(),
      tempFile: null
    }
  },
  computed: {
    loadedImage () {
      if (this.tempFile) {
        return `background-image: url(${this.tempFile});`
      } else if (this.loadState === 'loaded') {
        return 'background-image: url(' + this.asyncImage.src + ');'
      } else {
        return ''
      }
    },
    requiredClass () {
      return this.required ? 'is-essential' : ''
    },
    acceptStr () {
      if (this.accept) {
        return this.accept.join(', ')
      }
      return ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadState = ''
      this.asyncImage.onload = () => { this.loadState = 'loaded' }
      this.asyncImage.onerror = () => { this.loadState = 'failed' }
      this.asyncImage.src = `${this.url}`
    })
  },
  methods: {
    async fileUpload (file, config) {
      var formData = new FormData()
      formData.append('file', file)

      const res = await this.$http.post(`${this.url}`, formData, config)
      console.log('res', res)
      return res
    },
    async handleFileAdd (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }

      this.$emit('error', {})
      this.uploadStatus = ''

      const config = {
        onUploadProgress: progressEvent => {
          this.uploadStatus = `업로드 중: ${Math.round((progressEvent.loaded * 100) / progressEvent.total)}%`
          // this.$emit('fileUpload', `업로드 중: ${Math.round((progressEvent.loaded * 100) / progressEvent.total)}%`)
        }
      }
      try {
        const { data } = await this.fileUpload(files[0], config)
        this.tempFile = URL.createObjectURL(files[0])

        const file = {
          originalName: data.originalName,
          fileName: data.fileName,
          fileSize: data.fileSize,
          fileExt: data.fileExt
          // cancelToken
        }
        this.$emit('uploaded', file)
      } catch (ex) {
        // console.error(ex, ex.response)
        if (ex.response) {
          const { fieldId, errorMessage } = ex.response.data
          const error = { fieldId, errorMessage }
          this.$emit('error', error)
        }
        console.error(ex, ex.response)
      }
      this.uploadStatus = ''

      // this.$emit('fileUpload', ``)
    },
    removeFile () {
      this.tempFile = null
      this.loadState = ''
      this.$emit('removeFile')
    }
  },
  components: {
    FormButton: () => import('@/component/ui2/button/FormButton'),
    FormError: () => import('@/component/ui2/form/FormError'),
    HelpText: () => import('@/component/ui2/common/HelpText')
  }
}

</script>
